module.exports = __webpack_public_path__ + "static/media/FloorDivot_After.bd7e3bf9.jpg";